module.exports = __webpack_public_path__ + "img/40m1.d7dd2254.jpg";